import type { UserPreferencesNotificationsSwitchProps } from "./user-preferences-notifications-switch.type";

import { Switch } from "antd";

import { useUserPreferencesNotificationsSwitch } from "./user-preferences-notifications-switch.hook";

export const UserPreferencesNotificationsSwitch = ({
  channel,
  notificationKey,
  defaultChannels,
  userPreferencesNotifications,
  onNotificationSettingsChange,
}: UserPreferencesNotificationsSwitchProps) => {
  const { handleChange, isChecked } = useUserPreferencesNotificationsSwitch({
    channel,
    notificationKey,
    defaultChannels,
    userPreferencesNotifications,
    onNotificationSettingsChange,
  });
  return <Switch onChange={handleChange} checked={isChecked} />;
};
